import axiosInstance from "./axiosInstance.ts";

interface PaymentProps {
  third: {
    phoneNumber: string;
    firstName: string;
    lastName: string;
  };
  voucher: {
    currency: string;
    amount: number;
    additionalInformation: string;
    quantity: number;
  };
  service: { reference: any };
  otherData: { host: string; env: string };
}

export const submitPayment = async (data: PaymentProps) => {
  const response = await axiosInstance.post("/cashpay/online/payment", data);
  return response.data;
};

export const getPaymentStatus   = async (requestId: string) => {
  const response = await axiosInstance.get(`/vouchers/check/${requestId}`);
  //const response = await axiosInstance.getr(`/vouchers/requestId/${requestId}`);
  return response.data;
}
/*

{
  "success": true,
    "message": "Invoice paid.",
    "data": [
  {
    "currency": "XOF",
    "amount": 100,
    "state": 7,
    "reference": "01JK88764ZM4SAC5HEVRYVFK62",
    "code": "19039756",
    "codeV2": "19039756-01JK88764ZM4SAC5HEVRYVFK62-7",
    "createdAt": "2025-02-04T10:31:13+00:00",
    "thirdsIssuer": {
      "reference_tiers": "441",
      "logo": "https://cashpay-dev.s3.eu-west-1.amazonaws.com/vms/thirds/Semoa-siteint-633eaebc87b59.png",
      "rccm": "Marie Matoto",
      "address": "Matoto",
      "phoneNumber": "224601601698",
      "city": "Conakry",
      "nationality": "TG",
      "email": "niffobscurus@gmail.com",
      "socialReason": "Marie Matoto",
      "responsible": "Mr Marie Matoto",
      "status": true
    },
    "thirdsBeneficiary": {
      "reference_tiers": "17331408823669",
      "logo": "https://vms-new3.s3.eu-west-1.amazonaws.com/vms/thirds/weloveya-674da190beff7.jpg",
      "rccm": "WELOVEYA",
      "address": "Tokoin",
      "phoneNumber": "22893621757",
      "city": "Lomé",
      "nationality": "TG",
      "email": "gabin.epani@semoa-togo.com",
      "socialReason": "WELOVEYA",
      "responsible": "Talon",
      "status": null,
      "barnerFront": null
    },
    "thirdsHolder": {
      "reference_tiers": null,
      "lastName": "AFIJA",
      "firstName": "Semoa",
      "phoneNumber": "22893256599"
    },
    "service": {
      "quantity": 0,
      "name": "testTicket",
      "amount": 100,
      "reference": "01J9Y85C5G42DY5XJW5TZBXJEH",
      "printDisponibily": [
        0,
        1
      ],
      "currency": "XOF",
      "IsAmountChangeAuthorized": false,
      "minAmount": null,
      "maxAmount": null
    }
  }
]
}
*/
